import Filters, { livesearch } from "../../utils/_livesearch";

Filters.init("partners");

//let block = document.querySelector('.js-partners-listing');

let checkboxFilterSector = document.querySelector('.js-checkbox-filter-sector');
let checkboxFilterStatus = document.querySelector('.js-checkbox-filter-status');
let checkboxFilterLabel = document.querySelector('.js-checkbox-filter-label');
let resultNameSector = [];
let resultNameLabel = [];
let resultNameStatus = [];

let placeholderSector = checkboxFilterSector?.querySelector('.js-placeholder-container');

let placeholderStatus= checkboxFilterStatus?.querySelector('.js-placeholder-container');

let placeholderLabel = checkboxFilterLabel?.querySelector('.js-placeholder-container');

const placeholderDefaultSector = placeholderSector?.dataset.placeholder;

const placeholderDefaultStatus = placeholderStatus?.dataset.placeholder;

const placeholderDefaultLabel = placeholderLabel?.dataset.placeholder;

let resetFilters = document.querySelector('#resetFilters');

//const selectAll = document.querySelector('[js-select-all]');

document.addEventListener('DOMContentLoaded', () => {
    sortCards();
});

const sortCards = () => {
    const cards = Array.from(document.querySelectorAll('[data-title]'));
    cards.sort((a, b) => {
        const titleA = a.getAttribute('data-title').toLowerCase();
        const titleB = b.getAttribute('data-title').toLowerCase();
        return titleA.localeCompare(titleB); // This will sort alphabetically
    });
    const parentContainer = cards[0]?.parentElement; // assuming all cards have the same parent

    cards.forEach(card => parentContainer.appendChild(card));
}


// if (selectAll) {
//     selectAll.addEventListener('click', () => {
//         const checkboxes = checkboxFilterSector.querySelectorAll('input[type="checkbox"]');
//         checkboxes.forEach((checkbox) => {
//             if (selectAll.checked === true) {
//                 if (checkbox.checked === false) {
//                     checkbox.click();
//                 }
//             } else {
//                 resetFct(); 
//             }
//         });
//     });
// }

 
const handlePlaceholder = (checkboxFilter, placeholder, placeholderDefault, resultName) => {

    let checkboxes = checkboxFilter?.querySelectorAll('input[type="checkbox"]');

    if (checkboxes) {
        checkboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', () => {
                if (checkbox.checked) {
                    resultName.push(checkbox.closest('label')?.textContent?.trim());
                } else {
                    resultName.splice(resultName.indexOf(checkbox.closest('label')?.textContent?.trim()), 1);
                }
                if (resultName.length === 0) {
                    placeholder.innerHTML = placeholderDefault;
                } else {
                    placeholder.innerHTML = resultName.join(', ');
                }

            });
        });
    }
}

// Gestion du placeholder des filtres de type checkbox
if (checkboxFilterSector) {
    handlePlaceholder(checkboxFilterSector, placeholderSector, placeholderDefaultSector, resultNameSector);
}
if (checkboxFilterStatus) {
    handlePlaceholder(checkboxFilterStatus, placeholderStatus, placeholderDefaultStatus, resultNameStatus);
}
if (checkboxFilterLabel) {
    handlePlaceholder(checkboxFilterLabel, placeholderLabel, placeholderDefaultLabel, resultNameLabel);
}
// Reset des filtres
if (resetFilters) {
    resetFilters.addEventListener('click', () => {
        resetFct();
    });
}

const resetFct = () => {
    // Clear the arrays by resetting their length
    resultNameSector.length = 0;
    resultNameLabel.length = 0;
    resultNameStatus.length = 0;


    const sectorCheckboxes = checkboxFilterSector?.querySelectorAll('input[type="checkbox"]');
    const statusCheckboxes = checkboxFilterStatus?.querySelectorAll('input[type="checkbox"]');
    const labelCheckboxes = checkboxFilterLabel?.querySelectorAll('input[type="checkbox"]');
    
    if (sectorCheckboxes){
        sectorCheckboxes.forEach((checkbox) => {
            checkbox.checked = false; // Uncheck all sector checkboxes
        });
    }
    
    if (statusCheckboxes){
        statusCheckboxes.forEach((checkbox) => {
            checkbox.checked = false; // Uncheck all status checkboxes
        }); 
    }
    if (labelCheckboxes){
        labelCheckboxes.forEach((checkbox) => {
            checkbox.checked = false; // Uncheck all label checkboxes
        })
    }

    livesearch.reset();

    if (placeholderSector) {
        placeholderSector.innerHTML = placeholderDefaultSector;
    }
    if (placeholderLabel) {
        placeholderLabel.innerHTML = placeholderDefaultLabel;
    }
    


    if (placeholderStatus) {
        placeholderStatus.innerHTML = placeholderDefaultStatus;
    }
}

// Absent quand le formulaire de filtres n'est pas sur la page (éditeur).
livesearch?.on('afterChange', () => {
    sortCards();
});